import { render, staticRenderFns } from "./text.vue?vue&type=template&id=cd862b62&scoped=true&"
import script from "./text.vue?vue&type=script&lang=js&"
export * from "./text.vue?vue&type=script&lang=js&"
import style0 from "./text.vue?vue&type=style&index=0&id=cd862b62&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd862b62",
  null
  
)

export default component.exports